module.exports = __webpack_public_path__ + "static/media/[彩带]@2x.610f5060.png";